// // src/ApiContext.tsx
// import React, { createContext, useContext, ReactNode } from "react";
// import HttpService from "./HttpService";

// const ApiContext = createContext<HttpService | null>(null);

// export const ApiProvider: React.FC<{ children: ReactNode }> = ({
//   children,
// }) => {
//   const apiService = new HttpService();

//   return (
//     <ApiContext.Provider value={apiService}>{children}</ApiContext.Provider>
//   );
// };

// export const useApi = () => {
//   const context = useContext(ApiContext);
//   if (!context) {
//     throw new Error("useApi must be used within an ApiProvider");
//   }
//   return context;
// };

import React, { createContext, useContext, ReactNode, useMemo } from "react";
import HttpService from "./HttpService";
import { useAlert } from "../components/AlertContextComponent";
import Logger from "../utils/Logger";

const ApiContext = createContext<HttpService | null>(null);

let fallbackApiService: HttpService | null = null;

const getFallbackApiService = (): HttpService => {
  if (!fallbackApiService) {
    fallbackApiService = new HttpService((alertConfig: any) => {
      Logger.warn("Api alert without provider:", alertConfig);
    });
  }
  return fallbackApiService;
};

export const ApiProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { showAlert } = useAlert();
  const apiService = useMemo(() => new HttpService(showAlert), [showAlert]);

  return (
    <ApiContext.Provider value={apiService}>{children}</ApiContext.Provider>
  );
};

export const useApi = (): HttpService => {
  const context = useContext(ApiContext);
  if (!context) {
    return getFallbackApiService();
  }
  return context;
};
